import { useState } from "react";
import { Button } from "@chakra-ui/react";

import CustomDateSelector from "./CustomDateSelector";

interface Props {
  onTimeRangeChange: (startDate: Date, endDate: Date) => void;
}

const timeRanges = [
  { label: "1h", value: 1 },
  { label: "3h", value: 3 },
  { label: "6h", value: 6 },
  { label: "1d", value: 24 },
  { label: "3d", value: 72 },
  { label: "1w", value: 168 },
  { label: "1m", value: 720 },
]

function TimeRangeSelector({ onTimeRangeChange }: Props) {
  const [selectedTimeRange, setSelectedTimeRange] = useState("1d");
  const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);

  function onButtonClick(input: string) {
    setSelectedTimeRange(input)
    setShowCustomDatePicker(false);

    const selectedTimeRange = timeRanges.find((timeRange) => timeRange.label === input);

    if (selectedTimeRange) {
      const endDate = new Date();
      const startDate = new Date(endDate.getTime() - selectedTimeRange.value * 60 * 60 * 1000);
      onTimeRangeChange(startDate, endDate);
    }
  }

  return (
    <>
      <div style={styles.timeRangeSelector}>
        {timeRanges.map((timeRange) => (
          <Button
            key={timeRange.label}
            colorScheme={selectedTimeRange === timeRange.label ? "blue" : "gray"}
            onClick={() => onButtonClick(timeRange.label)}
            size="sm"
            sx={{ padding: '8px 10px' }}>
              {timeRange.label}
            </Button>
        ))}

        <Button
          size="sm"
          colorScheme={selectedTimeRange === "custom" ? "blue" : "gray"}
          sx={{ padding: "8px 10px" }}
          onClick={() => {
            setSelectedTimeRange("custom");
            setShowCustomDatePicker(true);
          }}
        >
          Custom
        </Button>
      </div>

      {showCustomDatePicker && (
        <CustomDateSelector
          onTimeRangeChange={onTimeRangeChange}
          style={{ marginBottom: 20 }}
        />
      )}
    </>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  timeRangeSelector: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginBottom: 20,
  },
};

export default TimeRangeSelector;
